<template>
    <div>
        <Interface :noHeader="true">
            <div class="mb-12">
                <template v-if="!isBusy && !empty && !error">

                    <!-- Card -->
                    <b-row :cols="row" class="mb-4">
                        <b-col v-for="item in items" :key="item.id" class="card-column" :cols="12">
                          <div :key="update">
                            <b-card class="card">
                                <slot :item="item"></slot>
                            </b-card>
                          </div>
                        </b-col>
                    </b-row>
                </template>

                <template v-else-if="empty">
                    <div class="text-center my-2">Não há registros até o momento.</div>
                </template>

                <template v-else-if="error">
                    <div class="text-center my-2">Erro: {{ error }}</div>
                </template>

                <template v-else>
                    <Loading></Loading>
                </template>

            </div>
        </Interface>
    </div>
</template>

<style lang="stylus">

@import '../../style/colors.styl';

.card-body
    background-color secondary

.card-title
    color primary

</style>

<script>
import { getAnaliseCompleta } from '@/services'
import Interface from '@/components/holders/Interface'
import Loading from '@/components/static/Loading'

export default {
  components: { Interface, Loading },
  props: {
    // Number of cards in a row
    row: {
      type: Number,
      default: 2
    },
    title: {
      type: String,
      required: false
    }
  },
  data: () => ({
    error: '',
    update: 0,
    items: [],
    loading: true,
    contentReady: false
  }),
  computed: {
    isBusy () { return this.loading || !this.contentReady },
    empty () { return !(this.items.length || this.isBusy) }
  },
  created () {
    this.getData()
  },
  methods: {
    markAnalysisReady () {
      this.contentReady = true
    },
    async loadCompleteByObjectId () {
      const analysisId = this.$route.params.object_id
      if (!analysisId) {
        this.error = 'Identificador da análise não informado.'
        this.loading = false
        this.$emit('analysis-loaded', null)
        return
      }

      try {
        const complete = await getAnaliseCompleta(analysisId)
        this.items = [{
          id: analysisId,
          url: complete.imageUrl || '',
          imageBlob: complete.imageBlob || null,
          analysisData: complete.details || null,
          grains: complete.grains || null,
          details: complete.details || null
        }]
        this.$emit('analysis-loaded', complete)
      } catch (e) {
        this.error = 'Imagens não encontradas.'
        this.$emit('analysis-loaded', null)
      } finally {
        this.loading = false
      }
    },
    async getData () {
      this.loading = true
      this.contentReady = false
      this.error = ''
      await this.loadCompleteByObjectId()
    }
  }
}
</script>
